import LayoutContainerBubbles from './LayoutContainerBubbles';
import BubbleFeedback from './BubbleFeedback';
import UserBubble from './UserBubble';
import AiChatbotBubble from './AiChatbotBubble';

import { Message } from '@/types/discover';

interface BubbleContainerProps {
  data: Message;
  isDashboard: boolean;
}

const AiChatBotContainer = ({ data, isDashboard }: BubbleContainerProps) => {
  const renderContent = () => {
    switch (data.sender) {
      case 'bot':
        return (
          <div className="flex w-full flex-col gap-[8px]">
            <AiChatbotBubble data={data} isDashboard={isDashboard} />
            {data.errorCode !== 500 && <BubbleFeedback data={data} />}
          </div>
        );
      case 'user':
        return <UserBubble data={data} isDashboard={isDashboard} />;
      case 'alert':
        return <AlertBubble data={data} />;
      default:
        return null;
    }
  };

  return <LayoutContainerBubbles data={data}>{renderContent()}</LayoutContainerBubbles>;
};

export default AiChatBotContainer;

const AlertBubble = ({ data }: { data: Message }) => {
  return (
    <div
      className=" whitespace-pre-wrap
    py-[24px] text-center text-gr-600 Caption1M12
    "
    >
      {data.text}
    </div>
  );
};
